import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getArendeNyaOppnaAntal,setofUpdatedashboardArende,decrypt,encrypt} from 'actions'
import {isEmpty,isUndefined, isEqual} from 'lodash'
import LinearProgress from '@material-ui/core/LinearProgress';
import {Grid} from '@material-ui/core'
import { withStyles } from '@material-ui/styles';
import compose from 'recompose/compose';
import { Progress } from 'reactstrap';
import { sv } from "date-fns/locale";
import {format}  from 'date-fns';
import moment from 'moment';
import axios from 'util/ApiDashboard'
import IntlMessages from 'util/IntlMessages';
const styles = props => ({
    colorPrimary: {
      backgroundColor: '#005C69',
    },
    barColorPrimary: {
      backgroundColor: '#B2DFDB',
    },
    MainProgress: {
        backgroundColor: '#0E898F40 !important',
        height:"8px !important",
        borderRadius:"30px",
    },
    scroll: {
        marginRight: '16px',
        marginLeft: '16px',
        paddingTop: '3px',
        paddingRight: '6px',
        '&::-webkit-scrollbar': {
            width: '5px'
        },
        
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
        },
        
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#12484B',
            outline: '1px solid transparent'
        }
    }
  });


function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardArende} = accountsData
    const { ArendeTopOppnaList,DashboardAnpassadFilterOption} = DashBoard;
    return {
        authUser,ArendeTopOppnaList,DashboardAnpassadFilterOption,updatedashboardArende
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getArendeNyaOppnaAntal: (Afid,userid,DashboardAnpassadFilterOption) => dispatch(getArendeNyaOppnaAntal(Afid,userid,DashboardAnpassadFilterOption)),
        setofUpdatedashboardArende: () => dispatch(setofUpdatedashboardArende()),
        decrypt: (encryptedData, iv) => dispatch(decrypt(encryptedData, iv)),
        encrypt: (data) => dispatch(encrypt(data)),
        dispatch
    };
}
const ColorCode=[
    '#DAA520',
    '#C0C0C0',
    '#b08d57'
]
class TopList extends Component {
    state={
        ArendeTopOppnaList:[],
        DashboardAnpassadFilterOption:[],
        intervaltype:this.props.intervaltype,
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.authUser.user_Afid;
        const userid = this.props.authUser.user_id;
        axios.get(`kontos/DashBoard/getANOA`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
            if(res.data.success){
                let endata = decrypt(res.data.encryptedData,res.data.iv)
                let ndate = JSON.parse(endata)
                this.setState({ 
                    ArendeTopOppnaList:ndate.results.ArendeTopOppnaList,
                    intervaltype:this.props.intervaltype
                });
                this.initiateInterval() 
                // this.setState({done: true}) 
                } 
      
         })
    }
    initiateInterval() {
        clearInterval(this.intervalID);
        this.intervalID= null
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){            
                    this.setState({done: false})  
                const Afid = this.props.authUser.user_Afid;
                const userid = this.props.authUser.user_id;
                axios.get(`kontos/DashBoard/getANOA`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
            if(res.data.success){
                let endata = decrypt(res.data.encryptedData,res.data.iv)
                let ndate = JSON.parse(endata)
                this.setState({ 
                    ArendeTopOppnaList:ndate.results.ArendeTopOppnaList,
                    intervaltype:this.props.intervaltype
                });
                this.initiateInterval() 
                // this.setState({done: true}) 
                }  
         })
            }
            },
            180000
        );           
    }
    componentDidUpdate=()=>{
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        if(parseInt(this.props.updatedashboardArende) === 1){
            axios.get(`kontos/DashBoard/getANOA`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
            if(res.data.success){
                let endata = decrypt(res.data.encryptedData,res.data.iv)
                let ndate = JSON.parse(endata)
                this.setState({ 
                    ArendeTopOppnaList:ndate.results.ArendeTopOppnaList,
                    intervaltype:this.props.intervaltype
                });
                this.initiateInterval() 
                // this.setState({done: true}) 
                } 
         })
            this.props.setofUpdatedashboardArende()
          }   
        if(!isEqual([...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],this.state.DashboardAnpassadFilterOption))
           {
            axios.get(`kontos/DashBoard/getANOA`,
        { params:encrypt(JSON.stringify({
            Afid:Afid,
            FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
            intervaltype:this.props.intervaltype,
            userid:userid
          }))
        })
        .then(res => {
            if(res.data.success){
                let endata = decrypt(res.data.encryptedData,res.data.iv)
                let ndate = JSON.parse(endata)
                this.setState({ 
                    ArendeTopOppnaList:ndate.results.ArendeTopOppnaList,
                    intervaltype:this.props.intervaltype
                });
                this.initiateInterval() 
                // this.setState({done: true}) 
                }   
         })
               this.setState({
                   DashboardAnpassadFilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption] 
               }) 
           }
           if(this.state.intervaltype !== this.props.intervaltype){
            axios.get(`kontos/DashBoard/getANOA`,
            { params:encrypt(JSON.stringify({
                Afid:Afid,
                FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
                intervaltype:this.props.intervaltype,
                userid:userid
              }))
            })
            .then(res => {
                if(res.data.success){
                    let endata = decrypt(res.data.encryptedData,res.data.iv)
                    let ndate = JSON.parse(endata)
                    this.setState({ 
                        ArendeTopOppnaList:ndate.results.ArendeTopOppnaList,
                        intervaltype:this.props.intervaltype
                    });
                    this.initiateInterval() 
                    // this.setState({done: true}) 
                    } 
             })
           }

       }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID= null
    }
    formatNumber=(number)=>{
        return `${(number).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`
    }

    render() {

        const { classes } = this.props;
        return (
            <div style={{ width: '100%', height: '100%', color: isUndefined(this.props.FontColor)?'#fff':this.props.FontColor }}>
            <div className="text-center">
                <h2 style={{ paddingTop: '12px',margin: '0', }}><b><IntlMessages id="DashBoard.Errand.Opened"/></b></h2>
                {/* <p style={{fontSize:"1rem", textTransform:"capitalize"}}>
                {
                    isEmpty([...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption].filter(item=>item.Meta === "DatumFrom" || item.Meta === "DatumTo"))?
                    `${format(new Date(), 'MMMM', { locale: sv })}`
                    :
                    <>
                    {`
                    ${
                        isEmpty([...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption].filter(item=>item.Meta === "DatumFrom"))?
                        moment(new Date()).format('YYYY-MM-DD'):
                        moment([...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption].filter(item=>item.Meta === "DatumFrom")[0].Value).format('YYYY-MM-DD')
                    }
                    -
                    ${
                        isEmpty([...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption].filter(item=>item.Meta === "DatumTo"))?
                        moment(new Date()).format('YYYY-MM-DD'):
                        moment([...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption].filter(item=>item.Meta === "DatumTo")[0].Value).format('YYYY-MM-DD')
                    }
                    `}
                    </>
                    
                }
                </p> */}
            </div>


            <div className={classes.scroll} style={{overflowY: "auto", height: this.props.setHeight > 1 ? this.props.setHeight : 325 ,overflowX:"hidden"}}>
                  {
                    isEmpty(this.state.ArendeTopOppnaList)?
                    <>
                    <Grid container spacing={1} className={"mb-1"}>
                        <Grid item xs={6} style={{fontSize:"1.2rem", fontWeight:"500"}}>
                            1....
                        </Grid>
                        <Grid item xs={6} style={{textAlign:"right",fontSize:"1.3rem", fontWeight:"300"}}>
                        <span style={{fontSize:"1.1rem", fontWeight:"300", marginRight: 5}}>
                            0
                            </span>
                            <span
                            style={{fontSize:".7rem", fontWeight:"300"}}
                            ><IntlMessages id="Days"/></span>
                        </Grid>
                        <Grid item xs={12} className="m-1">
                        <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}}
                        variant={"determinate"} style={{height:".8rem"}}  value={"60"}/>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}  className={"mb-1"}>
                        <Grid item xs={6} style={{fontSize:"1.2rem", fontWeight:"500"}}>
                            2....
                        </Grid>
                        <Grid item xs={6} style={{textAlign:"right"}}>
                            <span style={{fontSize:"1.1rem", fontWeight:"300", marginRight: 5}}>
                            0
                            </span>
                            <span
                            style={{fontSize:".7rem", fontWeight:"300"}}
                            ><IntlMessages id="Days"/></span>
                        </Grid>
                        <Grid item xs={12} className="m-1">
                        <LinearProgress   classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}}
                        variant={"determinate"} style={{height:".8rem"}} value={"50"}/>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} className={"mb-1"}>
                        <Grid item xs={6} style={{fontSize:"1.2rem", fontWeight:"500"}}>
                            3....
                        </Grid>
                        <Grid item xs={6} style={{textAlign:"right",fontSize:"1.3rem", fontWeight:"300"}}>
                        <span style={{fontSize:"1.1rem", fontWeight:"300", marginRight: 5}}>
                            0
                            </span>
                            <span
                            style={{fontSize:".7rem", fontWeight:"300"}}
                            ><IntlMessages id="Days"/></span>
                        </Grid>
                        <Grid item xs={12}  className="m-1">
                        <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}}
                        variant={"determinate"} style={{height:".8rem"}}   value={"30"}/>
                        </Grid>
                    </Grid>
                    </>
                    :
                    this.state.ArendeTopOppnaList.map((object,index) =>
                    // this.props.ArendeTopOppnaList.map((object,index) =>
                        <Grid container spacing={1} alignItems="center" >
                            <Grid item xs={9} style={{fontSize:"1.2rem", fontWeight:"300", marginBottom: '-0.4rem'}}>
                                <p>{index+1}. {`#${object.Arendenr} ${String(object.Beskrivning).slice(0, 20)}${String(object.Beskrivning).length > 20 ? '...' : ''}`}</p> 
                            </Grid>

                            <Grid item xs={3} style={{textAlign:"right"}}>
                                <span style={{fontSize:"1.1rem", fontWeight:"300", marginRight: 5}}>
                                {
                                    this.formatNumber(object.antal)
                                }
                                </span>
                                <span
                                style={{fontSize:".7rem", fontWeight:"300"}}>{'DAGAR '}</span>
                            </Grid>
                            <Grid item xs={12} style={{marginBottom: '0.6rem'}}>
                                <Progress multi className={classes.MainProgress}> 
                                    <Progress bar
                                    // style={{ backgroundColor: parseInt(object.DateDiff2) <= 0 ?"#C377E0": parseInt(object.DateDiff2) <= 7? '#7793F5' : '#44D1C2'}}
                                    style={{ backgroundColor:  "#C377E0"}}
                                    // color={parseInt(object.DateDiff2) <= 0 ?"danger": parseInt(object.DateDiff2) <= 7 ? "warning" : "defaultNoty2"}
                                    // style={{ backgroundColor: parseInt(object.DateDiff2) <= 0 ?"#FF7272": parseInt(object.DateDiff2) <= 7? '#FFC895' : '#93F8B3'}}
                                    value={parseInt(object.antal)} max={parseInt(object.antalmax)} />

                                </Progress>

                            </Grid>
                        </Grid>
                        )
                    }
                    </div>

        </div>
        );
    }
}

export default compose(
connect(
    mapStateToProps,mapDispatchToProps
),
withStyles(styles)
)(TopList);
